import Vue from 'vue'

import {library} from '@fortawesome/fontawesome-svg-core'
import {faSkype} from '@fortawesome/free-brands-svg-icons/faSkype'
import {faEdit} from '@fortawesome/free-regular-svg-icons/faEdit'
import {faTrashAlt} from '@fortawesome/free-regular-svg-icons/faTrashAlt'
import {faSave} from '@fortawesome/free-regular-svg-icons/faSave'
import {faClock} from '@fortawesome/free-regular-svg-icons/faClock'

import {faTrashAlt as fasTrashAlt} from '@fortawesome/free-solid-svg-icons/faTrashAlt'
import {faFileUpload} from '@fortawesome/free-solid-svg-icons/faFileUpload'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload'
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons/faPhoneAlt'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faUndo} from '@fortawesome/free-solid-svg-icons/faUndo'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faUserFriends} from "@fortawesome/free-solid-svg-icons/faUserFriends";
import {faThList} from "@fortawesome/free-solid-svg-icons/faThList";

library.add(
    faPhoneAlt,
    faEnvelope,
    faSkype,
    faUser,
    faEdit,
    faTrashAlt,
    fasTrashAlt,
    faSave,
    faUndo,
    faClock,
    faDownload,
    faPlus,
    faFileUpload,
    faCheckCircle,
    faExclamationCircle,
    faTimes,
    faTimesCircle,
    faTrash,
    faUserFriends,
    faThList,
);

Vue.component("fa", FontAwesomeIcon);
